module.exports = __webpack_public_path__ + "036767aa298c6bbe2dbaf723198b56db.pdf";